import axios from "axios";
import { updateGlobalLoader } from "../../components/backdrop/backdropSlice";
import { updateCommonData } from "../../redux/commonSlice";
import { Alert } from "../../utils/Alert";
import { api } from "../../utils/api";
import { encodedURI, getCompanyid, removeEmptyValues, setCompanyFlowStatus } from "../../utils/common";
import { BASE_URL } from "../../utils/constant";
import { endpoints } from "../../utils/endpoints";
import { ROUTES } from "../../utils/routes";
import { updateWallet } from "../wallet/walletSlice";
import { updateSubscription } from "./subscriptionSlice";

export const getAllCompany = () => {
  return (dispatch, getState) => {

    api.getApiCall(
      endpoints.brands,
      "",
      (respData) => {
        dispatch(updateSubscription({ brandsDropdown: respData.data.result.data, }));

      },
      (errors) => {
        console.log("error", errors);
      }
    );
  };
};

export const getAllSubscriptions = () => {
  return (dispatch, getState) => {
    const { limit, page, filters } = getState().subscriptionSlice;
    const filterData = encodedURI(removeEmptyValues(filters));
    api.getApiCall(
      endpoints.getAllSubscription,
      `?limit=${limit}&offset=${page * limit}&filter=${filterData}`,
      (respData) => {
        dispatch(updateSubscription({ listing: respData.data.result.data, totalCount: respData.data.result.count, totalPages: respData.data.result.count }));

      },
      (errors) => {
        console.log("error", errors);
      }
    );
  };
};
export const getSubscriptionHistory = () => {
  return (dispatch, getState) => {
    const { startDate, endDate } = getState().subscriptionSlice;
    api.getApiCall(
      endpoints.getPlanHistory + "/" + getCompanyid() + `?startDate=${startDate}&endDate=${endDate}`,
      ``,
      (respData) => {
        dispatch(updateSubscription({ history: respData.data.result }));

      },
      (errors) => {
        console.log("error", errors);
      }
    );
  };
};

export const getActivePlanDetails = (COMPANY_ID = null) => {
  return (dispatch, getState) => {
    const comapnyId = COMPANY_ID || getCompanyid()
    api.getApiCall(
      endpoints.getActivePlan + "/" + comapnyId,
      ``,
      (respData) => {
        dispatch(updateSubscription({
          planDetails: respData.data.result,
          planDetailsLoaded: true,
          recurringEndDate: respData.data.result.recurringEndDate?.userId || false
        }));
      },
      (errors) => {
        // Mark it resolved either way, otherwise the credits pill sits on a
        // skeleton forever when the plan call fails.
        console.log("error", errors);
        dispatch(updateSubscription({ planDetailsLoaded: true }));
      }
    );
  };
};
export const cancelRecurringSubscription = () => {
  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.getApiCall(
      endpoints.cancelRecurringSubscription,
      ``,
      (respData) => {
        dispatch(updateGlobalLoader(false));
        if (respData.data.status !== "SUCCESS") {
          dispatch(updateCommonData({
            message: respData.data.message,
            title: "Failed",
            img: "/failed.png",
            status: true
          }));
        } else {
          dispatch(getActivePlanDetails());
        }
      },
      (errors) => {
        dispatch(updateGlobalLoader(false));
        console.log("error", errors);
      }
    );
  };
};

export const subscriptionDetails = (id, setValue) => {
  return (dispatch, getState) => {
    api.getApiCall(
      endpoints.subscriptionDetails + `/${id}`,
      ``,
      (respData) => {
        dispatch(updateSubscription({ details: respData.data.result }));
        setValue(respData.data.result)
      },
      (errors) => {
        console.log("error", errors);
      }
    );
  };
};

export const getAllCompanyforDropdown = () => {
  return (dispatch, getState) => {
    api.getApiCall(
      endpoints.getAllCompanies,
      ``,
      (respData) => {
        dispatch(updateSubscription({ companyListing: respData.data.result }));
      },
      (errors) => {
        console.log("error", errors);
      }
    );
  };
};
export const getActiveDefaultPlan = () => {
  return (dispatch, getState) => {
    const { activeFilters } = getState().subscriptionSlice;
    const filterData = encodedURI(removeEmptyValues(activeFilters));
    api.getApiCall(
      endpoints.getAllSubscription,
      `?filter=${filterData}`,
      (respData) => {
        dispatch(updateSubscription({ defaultActivePlan: respData.data.result.data.length }));

      },
      (errors) => {
        console.log("error", errors);
      }
    );
  };
};

export const getAllActivePlans = () => {
  return (dispatch, getState) => {
    api.getApiCall(
      endpoints.getAllActivePlans + "/" + getCompanyid(),
      ``,
      (respData) => {
        dispatch(updateSubscription({ activePlans: respData.data.result.plan, currentActivePlan: respData.data.result.currentPlan }));
      },
      (errors) => {
        console.log("error", errors);
      }
    );
  };
};


export const getCompanyDetails = (id, navigate) => {
  return (dispatch, getState) => {
    api.getApiCall(
      endpoints.getCompanyById + `/${id}`,
      ``,
      (respData) => {
        respData.data.result.comingFrom = "profile";
        navigate("/company/profile/" + id, { state: respData.data.result })
      },
      (errors) => {
        console.log("error", errors);
      }
    );
  };
};
export const talkToExperts = (values, setOpen1, setMsg) => {
  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.postApiCall(
      endpoints.talktoExperts,
      values,
      (respData) => {
        dispatch(updateGlobalLoader(false));
        setOpen1(true)
        if (respData.data.status === "SUCCESS") {
          setMsg("Your request successfully submitted");
        } else {
          setMsg(respData.data.message);

        }
      },
      (error) => {
        dispatch(updateGlobalLoader(false));
        let { data } = error;
        dispatch(updateCommonData({
          message: data.message,
          title: "Failed",
          img: "/failed.png",
          status: true
        }));

      }
    );
  }


}


export const createSubscription = (values, navigate) => {
  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.postApiCall(
      endpoints.addSubscription,
      values,
      (respData) => {
        dispatch(updateGlobalLoader(false));
        if (respData.data.status === "SUCCESS") {
          dispatch(updateCommonData({
            message: `Your plan has been ${values.id ? "updated" : 'created'} successfully `,
            title: "Success",
            img: "/success2.png",
            status: true
          }));
          navigate(ROUTES.SUBSCRIPTION_MGT)
        } else {
          dispatch(updateCommonData({
            message: respData.data.message,
            title: "Failed",
            img: "/failed.png",
            status: true
          }));

        }
      },
      (error) => {
        dispatch(updateGlobalLoader(false));
        let { data } = error;
        dispatch(updateCommonData({
          message: data.message,
          title: "Failed",
          img: "/failed.png",
          status: true
        }));

      }
    );
  }


}

export const updateSubscriptionQandA = (values, hideModal) => {
  return (dispatch, getState) => {
    //dispatch(updateGlobalLoader(true));
    api.patchApiCall(
      endpoints.updateSubscriptionQandA + `/${getCompanyid()}`,
      values,
      (respData) => {
        // dispatch(updateGlobalLoader(false));
        hideModal(false);
        setCompanyFlowStatus(0);
      },
      (error) => {
        //dispatch(updateGlobalLoader(false));
        let { data } = error;
        dispatch(updateCommonData({
          message: data.message,
          title: "Failed",
          img: "/failed.png",
          status: true
        }));
      }
    );


  }
}

export const subscriptionCustomPayment = (payload) => {
  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.postApiCall(
      endpoints.customPayment,
      payload,
      (respData) => {
        dispatch(updateGlobalLoader(false));
        if (respData.data.status === "SUCCESS") {
          dispatch(updateCommonData({
            message: "Payment link send successfully on your email",
            title: "Success",
            img: "/success.png",
            status: true
          }));
        } else {
          dispatch(updateCommonData({
            message: respData.data.result.message || "Api error",
            title: "Failed",
            img: "/failed.png",
            status: true
          }));
        }
      },
      (error) => {
        dispatch(updateGlobalLoader(false));
        let { data } = error;
        Alert(2, data?.msg);
      }
    );
  };
};

export const subscriptionPayment = (payload) => {
  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.postApiCall(
      endpoints.subscriptionPayment,
      payload,
      (respData) => {
        dispatch(updateGlobalLoader(false));
        if (respData.data.status === "SUCCESS") {
          window.open(respData.data.result.result, "_blank")
        } else {
          alert(respData?.data?.message);
          // dispatch(updateCommonData({
          //   message: respData?.data?.message || "Api error",
          //   title: "Failed",
          //   img: "/failed.png",
          //   status: true
          // }));
        }
      },
      (error) => {
        dispatch(updateGlobalLoader(false));
        let { data } = error;
        Alert(2, data?.msg);
      }
    );
  };
};

export const triggerAdminWalletPaymentOtp = (payload, startTimer = () => { }) => {
  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.postApiCall(
      endpoints.sendAdminOtpForWalletAddMoney, payload, (resData) => {
        dispatch(updateGlobalLoader(false));
        if (resData?.data?.status === "SUCCESS") {
          startTimer();
          Alert(1, "OTP Sended Successfully!");
          dispatch(updateWallet({ sendOtp: true }))
        }
        else {
          Alert(2, resData?.message);
          dispatch(updateWallet({ sendOtp: false }))
        }
      }, (error) => {
        dispatch(updateGlobalLoader(false));
        dispatch(updateWallet({ sendOtp: false }))
        let { data } = error;
        Alert(2, data?.message);
      }
    )
  }
}
export const verifyCompanyPayment = async (payload) => {
  try {
    const res = await axios.post(BASE_URL + endpoints.verifyCompanyPayment, payload, {
      headers: {
        "Authorization": localStorage.getItem("token") || ""
      },
    })
    if (res.data.status === "SUCCESS") {
      Alert(1, res.data.message);
    } else {
      Alert(2, res.data.message);
    }
    return res?.data?.status;
  } catch (error) {
    Alert(1, error?.data?.message);
    return error;
  }
}

export const updateSubscriptionStatus = (id, status) => {
  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.postApiCall(
      endpoints.subscriptionStatusUpdate + `/${id}`,
      { status: status },
      (respData) => {
        dispatch(updateGlobalLoader(false));
        if (respData.data.status !== "SUCCESS") {
          dispatch(updateCommonData({
            message: "something went to wrong",
            title: "Failed",
            img: "/failed.png",
            status: true
          }));
          return;
        }
        dispatch(getAllSubscriptions());
      },
      (error) => {
        dispatch(updateGlobalLoader(false));
        let { data } = error;
        dispatch(updateCommonData({
          message: data.message,
          title: "Failed",
          img: "/failed.png",
          status: true
        }));
      }
    );
  };
};



export const updateUserStatus = (postData) => {

  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.patchApiCall(
      endpoints.updateUserStatus,
      postData,
      (respData) => {
        dispatch(updateGlobalLoader(false));
        let res = respData.data;
        dispatch(updateCommonData({
          message: "Status successfully updated",
          title: "Success",
          img: "/success.png",
          status: true
        }));
      },
      (error) => {
        dispatch(updateGlobalLoader(false));
        let { data } = error;
        dispatch(updateCommonData({
          message: data?.msg || "Api error",
          title: "Failed",
          img: "/failed.png",
          status: true
        }));
        //Alert(2, data?.msg);
      }
    );
  };
};


export const getAllInfluencerSubscriptions = () => {
  return (dispatch, getState) => {
    const { limit, page, filters } = getState().subscriptionSlice;
    const filterData = encodedURI(removeEmptyValues(filters));
    api.getApiCall(
      endpoints.influencerSubscriptionList,
      `?limit=${limit}&offset=${page * limit}&search=${filters.name || ''}&type=${filters.type || ''}&startDate=${filters.startDate || ''}&endDate=${filters.endDate || ''}`,
      (respData) => {
        dispatch(updateSubscription({ influencerListing: respData.data.result.list, influencerTotalCount: respData.data.result.count, totalPages: respData.data.result.count }));
      },
      (errors) => {
        console.log("error", errors);
      }
    );
  };
};

export const disableInfluencerSubscription = (id) => {
  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.patchApiCall(
      endpoints.disableInfluencerSubscription + `/${id}`,
      {},
      (respData) => {
        dispatch(updateGlobalLoader(false));
        if (respData.data.status === "SUCCESS") {
          dispatch(updateCommonData({
            message: "Subscription disabled successfully",
            title: "Success",
            img: "/success.png",
            status: true
          }));
          dispatch(getAllInfluencerSubscriptions());
        } else {
          dispatch(updateCommonData({
            message: respData.data.message || "Something went wrong",
            title: "Failed",
            img: "/failed.png",
            status: true
          }));
        }
      },
      (error) => {
        dispatch(updateGlobalLoader(false));
        console.log("error", error);
        dispatch(updateCommonData({
          message: error?.data?.message || "Api error",
          title: "Failed",
          img: "/failed.png",
          status: true
        }));
      }
    );
  };
};

export const getInfluencerSubscriptionDetails = (id, setData) => {
  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.getApiCall(
      endpoints.influencerSubscriptionDetails + `/${id}`,
      ``,
      (respData) => {
        dispatch(updateGlobalLoader(false));
        if (respData.data.status === "SUCCESS") {
          setData(respData.data.result);
        }
      },
      (errors) => {
        dispatch(updateGlobalLoader(false));
        console.log("error", errors);
      }
    );
  };
};

export const assignInfluencerSubscription = (values, navigate) => {
  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.postApiCall(
      endpoints.assignInfluencerSubscription,
      values,
      (respData) => {
        dispatch(updateGlobalLoader(false));
        if (respData.data.status === "SUCCESS") {
          dispatch(updateCommonData({
            message: "Subscription assigned successfully",
            title: "Success",
            img: "/success.png",
            status: true
          }));
          navigate(ROUTES.INFLUENCER_SUBSCRIPTION_LIST);
        } else {
          dispatch(updateCommonData({
            message: respData.data.message || "Something went wrong",
            title: "Failed",
            img: "/failed.png",
            status: true
          }));
        }
      },
      (error) => {
        dispatch(updateGlobalLoader(false));
        console.log("error", error);
        dispatch(updateCommonData({
          message: error?.data?.message || "Api error",
          title: "Failed",
          img: "/failed.png",
          status: true
        }));
      }
    );
  };
};

export const getInfluencersForDropdown = (search, setOptions) => {
  return (dispatch, getState) => {
    // dispatch(updateGlobalLoader(true));
    api.getApiCall(
      endpoints.dashboardInfluencerList,
      `?limit=20&offset=0&filter=${search ? encodedURI(JSON.stringify({ name: search })) : ''}`,
      (respData) => {
        // dispatch(updateGlobalLoader(false));
        if (respData.data.status !== "FAILURE") {
          setOptions(respData.data.result.data || []);
        }
      },
      (error) => {
        // dispatch(updateGlobalLoader(false));
        console.log("error", error);
      }
    );
  };
};

export const getInfluencerPlanDetails = (type, setData) => {
  return (dispatch, getState) => {
    dispatch(updateGlobalLoader(true));
    api.getApiCall(
      endpoints.influencerSubscriptionTypeDetails + `/${type}`,
      ``,
      (respData) => {
        dispatch(updateGlobalLoader(false));
        if (respData.data.status === "SUCCESS") {
          setData(respData.data.result);
        }
      },
      (errors) => {
        dispatch(updateGlobalLoader(false));
        console.log("error", errors);
      }
    );
  };
};

export const getAllInfluencerSubscriptionTypes = (setData) => {
  return (dispatch, getState) => {
    // dispatch(updateGlobalLoader(true));
    api.getApiCall(
      endpoints.getAllInfluencerSubscriptionTypes,
      ``,
      (respData) => {
        // dispatch(updateGlobalLoader(false));
        if (respData.data.status === "SUCCESS") {
          setData(respData.data.result);
        }
      },
      (errors) => {
        // dispatch(updateGlobalLoader(false));
        console.log("error", errors);
      }
    );
  };
};
